export const ClientFeatureSettings = {
  GenderFilter: [60]
}


// WEBPACK FOOTER //
// ./src/settings/clientFeatureSettings.js